/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The current state of the Zoom credential.

- `active`: Credential is working and can be used
- `invalid`: Credential has failed (tokens revoked, expired, etc.)
 */
export type GetZoomCredential200DataState =
  (typeof GetZoomCredential200DataState)[keyof typeof GetZoomCredential200DataState]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetZoomCredential200DataState = {
  active: "active",
  invalid: "invalid"
} as const
